import React from 'react'

const RightAlignHeaderColumn = ({ column }) => {
  return (
    <span style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>{column.name}</span>
  )
}

export default RightAlignHeaderColumn